import { Box, BoxProps } from '@mui/material';

export type MultipleProgressBarsItemProps = {
  value: number;
  color?: string;
  stacked?: boolean;
  sx?: BoxProps['sx'];
  size?: string;
  testId?: string;
};

export const MultipleProgressBarsItem = (
  props: MultipleProgressBarsItemProps
) => {
  return (
    <Box
      data-testid={props.testId}
      sx={{
        '.ds-multiple-progress-bars-container-sm &': {
          '--ds-multiple-progress-bars-item-size': '2px',
        },
        '.ds-multiple-progress-bars-container-md &': {
          '--ds-multiple-progress-bars-item-size': '4px',
        },
        '.ds-multiple-progress-bars-container-lg &': {
          '--ds-multiple-progress-bars-item-size': '8px',
        },
        bgcolor: props.color,
        position: 'relative',
        maxWidth: '100%',
        flexGrow: props.value,
        height: 'var(--ds-multiple-progress-bars-item-size)',
        borderRadius: '24px',
        ...props.sx,

        '.ds-multiple-progress-bars-container-stacked &': {
          minWidth: 'var(--ds-multiple-progress-bars-item-size)',
          borderTopLeftRadius: '0',
          borderBottomLeftRadius: '0',

          '&:before': {
            content: '""',
            bgcolor: props.color,
            height: 'var(--ds-multiple-progress-bars-item-size)',
            width: 'max(var(--ds-multiple-progress-bars-item-size), 3px)',
            display: 'flex',
            left: 'min(calc(var(--ds-multiple-progress-bars-item-size) * -1), -3px)',
            position: 'absolute',
          },
        },

        '&:first-of-type': {
          marginLeft: '0px',
          borderRadius: '24px',
          '&:before': {
            display: 'none',
          },
        },
      }}
    />
  );
};

MultipleProgressBarsItem.displayName = 'MultipleProgressBarsItem';
